import {Component, Inject, OnInit} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {File, Folder, Mutation} from '../types-repository';
import {Apollo, gql} from 'apollo-angular';
import {FILE_FOLDER_LIST_WITH_ARCHIVE} from '../queries-repository';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: []
})
export class ErrorDialogComponent implements OnInit {

  constructor(public dialogRef: DialogRef<string>,
              @Inject(DIALOG_DATA) public data: { message: string, messages: string[], button: string }) {
  }

  ngOnInit(): void {
  }


}
